import { DateInput } from 'nhsuk-react-components';
import type { DateInputChangeEvent } from 'nhsuk-react-components';
import React from 'react';
import { LabelDate } from '../../utils/formattingUtils';

interface IterationRunDateProps {
  value: LabelDate;
  onChange: (e: DateInputChangeEvent) => void;
  error?: string;
}

// eslint-disable-next-line react/function-component-definition
const IterationRunDate: React.FC<IterationRunDateProps> = ({
  value,
  onChange,
  error,
}) => (
  <div>
    <h4>Planned run date</h4>
    <p>
      This is the first date that the iteration will run. If it&apos;s a
      repeating iteration, the subsequent runs will be based on this
      date.
    </p>
    <DateInput
      id="iteration-date"
      aria-label="iteration-date"
      data-testid="iteration-date"
      onChange={onChange}
      value={value}
      error={error}
    />
  </div>
);

export default IterationRunDate;
